/* eslint-disable */
<template>
  <div>
    <div class="bg"></div>
    <div class="internalStats">
      <div class="userWatch">
        <div class="viewToggles flex">
          <div
            @click="setCurrentView('users')"
            class="viewToggle"
            :class="currentView == 'users' ? 'selectedView' : ''"
          >
            Users view
          </div>
          <div
            @click="setCurrentView('sessions')"
            class="viewToggle"
            :class="currentView == 'sessions' ? 'selectedView' : ''"
          >
            Sessions view
          </div>
          <div
            @click="setCurrentView('stats')"
            class="viewToggle"
            :class="currentView == 'stats' ? 'selectedView' : ''"
          >
            General stats
          </div>
          <div
            @click="setCurrentView('badges')"
            class="viewToggle"
            :class="currentView == 'badges' ? 'selectedView' : ''"
          >
            Badge controller
          </div>
          <CrazyTown
            v-if="allowedNero"
            icon="🦄"
            iconType="unicorn"
            useCase="nyan"
            :closed="nyanClosed"
            @open="openBox('nyan')"
            @close="closeBox('nyan')"
            image="https://ik.imagekit.io/elysiumone/nyan_eFA09_mVs.png"
          />
          <CrazyTown
            v-if="allowedNero"
            icon="🐶"
            iconType="unicorn"
            useCase="dog"
            ref="dog"
            :closed="dogClosed"
            @open="openBox('dog')"
            @close="closeBox('dog')"
            image="https://ik.imagekit.io/elysiumone/dog_NJ837360-.png"
          />
          <router-link v-if="allowedNero" class="flamingo" to="/flamingo">🦩</router-link>
        </div>
        <div class="countdown-box" v-if="allowedNero">
          <h1 id="headline" @click="toggleCountdown">
            ❤️ Countdown to Rob & Ness meeting (Oct 1) ❤️
          </h1>
          <div id="countdown">
            <ul class="countdown-parts">
              <li><span id="days" class="countdown-part"></span>days</li>
              <li><span id="hours" class="countdown-part"></span>Hours</li>
              <li><span id="minutes" class="countdown-part"></span>Minutes</li>
              <li><span id="seconds" class="countdown-part"></span>Seconds</li>
            </ul>
          </div>
          <div v-if="countdownChange" style="display: flex">
            <input v-model="countdownDate" />
            <button @click="changeCountdown">Update date</button>
          </div>
          <!-- <div id="content" class="emoji">
              <span>🥳</span>
              <span>🎉</span>
              <span>🎂</span>
            </div> -->
        </div>
        <div class="ness-start" v-if="!arrived">
          🦄: Wow!! Is Ness approaching 400 sessions...! I wonder what will happen then...
        </div>
        <div class="ness-start" v-if="arrived">
          🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄 🦄
        </div>
        <Nyan300 :closed="nyanClosed" @close="closeBox('nyan')" @open="openBox('nyan')" />
        <Dog400 :closed="dogClosed" @close="closeBox('dog')" @open="openBox('dog')" />
        <div></div>
        <BadgeController v-if="currentView == 'badges'" />
        <div class="usersArea" v-if="currentView == 'users' || currentView == 'sessions'">
          <div class="userPreviews">
            <button @click="refreshData">
              {{ refreshingData ? "Refreshing..." : "Refresh data" }}
            </button>
            <button @click="clearSelection" class="clearSelection">
              Clear selection
            </button>
            <div v-if="currentView == 'users'" class="usersRegistered">{{ allUsersCount }} Users Registered</div>
            <div v-if="currentView == 'sessions'" class="usersRegistered">
              {{ upcomingSessionsFor8Days && upcomingSessionsFor8Days.length ? upcomingSessionsFor8Days.length : "?" }}
              Upcoming sessions for next 8 days
            </div>
            <input
              v-if="currentView == 'users'"
              type="text"
              class="search"
              v-model="search"
              :placeholder="currentView == 'users' ? 'Search users...' : 'Search sessions...'"
            />
            <div>
              Find one user by ID/email:
              <input v-if="currentView == 'users'" type="text" class="search" v-model="userToFindID" />
              <button @click="getOneUser">Get user</button>
            </div>
            <UserSearchTypes v-if="currentView == 'users'" @setSearchType="setSearchType" />
            <UserSortTypes v-if="currentView == 'users'" @setSortType="setSortType" />
            <SessionSearchTypes v-if="currentView == 'sessions'" @setSearchType="setSearchType" />
            <div v-if="this.upcomingSessionsFor8Days && this.upcomingSessionsFor8Days.length">
              <div v-if="filteredSessions && filteredSessions.length">
                Loaded: {{ filteredSessions.length }} sessions of this kind.
              </div>
            </div>
            <div v-if="!filteredSessions || !filteredSessions.length">
              Loaded 0 sessions of this kind.
            </div>
            <div
              v-if="
                allUsers &&
                  allUsers.length &&
                  currentView == 'users' &&
                  upcomingSessionsFor8Days &&
                  upcomingSessionsFor8Days.length
              "
              class="allUsers"
            >
              <UserPreview
                v-for="(user, index) in filteredUsers"
                :upcomingSessions="upcomingSessionsFor8Days"
                :key="user._id"
                :user="user"
                :index="index + 1"
                :allowedUserViewing="allowedUserViewing"
                :isSelected="selectedUser && selectedUser._id == user._id"
                @select="selectUser"
              />
            </div>
            <div
              v-if="upcomingSessionsFor8Days && upcomingSessionsFor8Days.length && currentView == 'sessions'"
              class="allUsers"
            >
              <SessionPreview
                v-for="session in filteredSessions"
                :key="session._id"
                :session="session"
                :isSelected="selectedSession && selectedSession._id == session._id"
                @select="selectSession"
              />
            </div>
          </div>
          <div class="selected" v-if="selectedUser">
            <div class="selectedTitle">Selected user</div>
            <User
              ref="user"
              :user="selectedUser"
              :upcomingSessions="upcomingSessionsFor8Days"
              :selectedSession="selectedSession"
              :selectedPastSession="selectedPastSession"
              :allowedUserViewing="allowedUserViewing"
              :rectifyingInProgress="rectifyingInProgress"
              @select="selectSession"
              @selectPastSession="selectPastSession"
              @manuallyVerify="manuallyVerify"
              @rectifyAccount="rectifyAccount"
            />
          </div>
          <div class="selected" v-if="selectedSession">
            <div class="selectedTitle">Selected upcoming session</div>
            <Session
              :session="selectedSession"
              :allowedUserViewing="allowedUserViewing"
              @selectUser="selectUser"
              @toggleRematchValue="toggleRematchValue"
            />
          </div>
          <div class="selected" v-if="selectedPastSession">
            <div class="selectedTitle">Selected past session</div>
            <PastSession
              :session="selectedPastSession"
              :allowedUserViewing="allowedUserViewing"
              @selectUser="selectUser"
              @toggleRematchValue="toggleRematchValue"
              @rectifySession="rectifySession"
            />
          </div>
        </div>
        <GeneralStats v-if="currentView == 'stats' && allUsers && allUsers.length" :allUsers="allUsers" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CrazyTown from "./CrazyTown.vue";
import Nyan300 from "./Ness/Nyan300.vue";
import Dog400 from "./Ness/Dog400.vue";
import {
  getUser,
  getAllUsersCount,
  getAllUsers,
  getUpcomingSessionsFor8Days,
  manuallyVerify,
  toggleRematchValue,
  rectifySession,
  rectifyAccount,
} from "./InternalHelpers";
import User from "./Blocks/User";
import UserPreview from "./Blocks/UserPreview";
import UserSearchTypes from "./Blocks/UserSearchTypes";
import UserSortTypes from "./Blocks/UserSortTypes";
import SessionSearchTypes from "./Blocks/SessionSearchTypes";
import SessionPreview from "./Blocks/SessionPreview";
import Session from "./Blocks/Session";
import PastSession from "./Blocks/PastSession";
import GeneralStats from "./Blocks/GeneralStats";
import BadgeController from "./Blocks/BadgeController.vue";

export default {
  name: "InternalStats",
  data() {
    return {
      countdownChange: false,
      countdownDate: "Sep 28, 2021 11:30:00",
      countdownInterval: null,

      userToFindID: "",

      arrived: true,
      nyanClosed: true,
      dogClosed: true,

      allUsersCount: 0,

      upcomingSessionsFor8Days: null,

      filteredOutCurrentSessions: null,

      allUsers: [],

      selectedUser: null,
      selectedSession: null,

      selectedPastSession: null,

      session: null,

      /* STATES */
      refreshingData: false,

      search: "",

      reversed: true,
      earliestFirst: true,

      searchType: "displayName",
      sortType: "createdAt",

      currentView: "users",

      allowed_users: ["60c9fa0c7a094a83b383867b", "60146eadbcf3e522d5d9ab6e", "60146e6875f16e2295b89cba"],

      rectifyingInProgress: false,
    };
  },
  components: {
    User,
    UserPreview,
    SessionSearchTypes,
    UserSearchTypes,
    UserSortTypes,
    SessionPreview,
    Session,
    PastSession,
    GeneralStats,
    CrazyTown,
    Nyan300,
    Dog400,
    BadgeController,
  },
  mounted() {
    this.startCountdown();
  },
  computed: {
    ...mapState({
      authUser: (state) => state.auth.user,
    }),
    allowedNero() {
      const allowed_ids = ["60c9fa0c7a094a83b383867b", "60146e6875f16e2295b89cba"];
      if (allowed_ids.includes(this.authUser._id)) {
        return true;
      }
      return false;
    },
    allowedUserViewing() {
      let allowed = false;
      if (this.authUser && this.authUser._id) {
        if (this.allowed_users.includes(this.authUser._id)) {
          allowed = true;
        }
      }
      return allowed;
    },
    filteredUsers() {
      let users = this.allUsers;
      if (this.reversed) {
        if (this.sortType == "createdAt") {
          users = users.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        } else if (this.sortType == "sessionCount") {
          users = users.sort(function(a, b) {
            if (!a.sessionCount && a.sessionCount !== 0) {
              a.sessionCount = 0;
            }
            if (!b.sessionCount && b.sessionCount !== 0) {
              b.sessionCount = 0;
            }
            return b.sessionCount - a.sessionCount;
          });
        } else if (this.sortType == "lastOnline") {
          users = users.sort(function(a, b) {
            if (!a.lastAwardedBadgeCheckDate) {
              a.lastAwardedBadgeCheckDate = new Date(0);
            }
            if (!b.lastAwardedBadgeCheckDate) {
              b.lastAwardedBadgeCheckDate = new Date(0);
            }
            return new Date(b.lastAwardedBadgeCheckDate) - new Date(a.lastAwardedBadgeCheckDate);
          });
        }
      } else {
        if (this.sortType == "createdAt") {
          users = users.sort(function(a, b) {
            return new Date(a.createdAt) - new Date(b.createdAt);
          });
        } else if (this.sortType == "sessionCount") {
          users = users.sort(function(a, b) {
            if (!a.sessionCount && a.sessionCount !== 0) {
              a.sessionCount = 0;
            }
            if (!b.sessionCount && b.sessionCount !== 0) {
              b.sessionCount = 0;
            }
            return a.sessionCount - b.sessionCount;
          });
        } else if (this.sortType == "lastOnline") {
          users = users.sort(function(a, b) {
            if (!a.lastAwardedBadgeCheckDate) {
              a.lastAwardedBadgeCheckDate = new Date(0);
            }
            if (!b.lastAwardedBadgeCheckDate) {
              b.lastAwardedBadgeCheckDate = new Date(0);
            }
            return new Date(a.lastAwardedBadgeCheckDate) - new Date(b.lastAwardedBadgeCheckDate);
          });
        }
      }
      return users.filter((user) => {
        if (this.search && this.search.length) {
          if (user[this.searchType]) {
            return user[this.searchType].toLowerCase().includes(this.search.toLowerCase());
          } else {
            return;
          }
        } else {
          return user;
        }
      });
    },

    filteredSessions() {
      let sessions = this.upcomingSessionsFor8Days;
      if (!sessions || !sessions.length) return;

      const now = Date.now();

      if (this.earliestFirst) {
        sessions = sessions.sort(function(a, b) {
          return new Date(a.dateTime) - new Date(b.dateTime);
        });
      }
      return sessions.filter((session) => {
        if (this.searchType == "all") {
          let dateTime = new Date(session.dateTime).valueOf();
          if (dateTime > now) {
            return session;
          }
        } else if (this.searchType == "unmatched") {
          if (session.UIDs && session.UIDs.length && session.UIDs.length < 2) {
            return session;
          }
        } else if (this.searchType == "matched") {
          if (session.UIDs && session.UIDs.length && session.UIDs.length > 1) {
            return session;
          }
        } else if (this.searchType == "current") {
          let dateTime = new Date(session.dateTime).valueOf();
          if (dateTime < now) {
            return session;
          }
        } else if (this.searchType == "bothjoined") {
          let allUIDs = [];
          if (session && session.timestamps && session.timestamps.length) {
            console.log("sesh", session);
            console.log("stamps", session.timestamps);
            console.log("stampsolo", session.timestamps[0]);
            for (var i = 0; i < session.timestamps.length; i++) {
              let stamp = session.timestamps[i];
              let UID = stamp.UID;
              console.log("uid: ", UID);
              if (!allUIDs.includes(UID)) {
                allUIDs.push(UID);
              }
            }
            console.log("the UIDs", allUIDs);
            if (allUIDs.length === 2) {
              let dateTime = new Date(session.dateTime).valueOf();
              if (dateTime < now) {
                return session;
              }
            } else {
              return null;
            }
          }
          return null;
        } else if (this.searchType == "onehasjoined") {
          let allUIDs = [];
          if (session && session.timestamps && session.timestamps.length) {
            console.log("sesh", session);
            console.log("stamps", session.timestamps);
            console.log("stampsolo", session.timestamps[0]);
            for (var k = 0; k < session.timestamps.length; k++) {
              let stamp = session.timestamps[k];
              let UID = stamp.UID;
              console.log("uid: ", UID);
              if (!allUIDs.includes(UID)) {
                allUIDs.push(UID);
              }
            }
            console.log("the UIDs", allUIDs);
            if (allUIDs.length === 1) {
              let dateTime = new Date(session.dateTime).valueOf();
              if (dateTime < now) {
                return session;
              }
            } else {
              return null;
            }
          }
          return null;
        } else if (this.searchType == "nonejoined") {
          if (!session.timestamps || !session.timestamps.length) {
            let dateTime = new Date(session.dateTime).valueOf();
            if (dateTime < now) {
              return session;
            }
          }
        }
      });
    },
  },
  async created() {
    await this.refreshData();
  },
  methods: {
    async refreshData() {
      this.refreshingData = true;
      this.allUsersCount = await getAllUsersCount();
      this.allUsers = await getAllUsers(); // changed in backend to only get last 30
      this.upcomingSessionsFor8Days = await getUpcomingSessionsFor8Days();
      if (this.selectedUser) {
        this.selectUser(this.selectedUser._id);
      }
      if (this.selectedSession) {
        this.selectSession(this.selectedSession._id);
      }
      this.refreshingData = false;
    },
    changeCountdown() {
      if (this.countdownChange) {
        clearInterval(this.countdownInterval);
        this.startCountdown();
        this.countdownChange = false;
      }
    },
    toggleCountdown() {
      if (this.countdownChange) {
        clearInterval(this.countdownInterval);
        this.startCountdown();
        this.countdownChange = false;
      } else {
        this.countdownChange = true;
      }
    },
    startCountdown() {
      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      // let birthday = "Oct 1, 2021 12:00:00",
      let birthday = this.countdownDate;
      let countDown = new Date(birthday).getTime();
      this.countdownInterval = setInterval(function() {
        let now = new Date().getTime();
        let distance = countDown - now;

        const days = document.getElementById("days");
        const hours = document.getElementById("hours");
        const minutes = document.getElementById("minutes");
        const seconds = document.getElementById("seconds");

        if (days) {
          days.innerText = Math.floor(distance / day);
        }
        if (hours) {
          hours.innerText = Math.floor((distance % day) / hour);
        }
        if (minutes) {
          minutes.innerText = Math.floor((distance % hour) / minute);
        }
        if (seconds) {
          seconds.innerText = Math.floor((distance % minute) / second);
        }

        //do something later when date is reached
        if (distance < 0) {
          // let headline = document.getElementById("headline"),
          //   countdown = document.getElementById("countdown"),
          //   content = document.getElementById("content");

          // headline.innerText = "It's my birthday!";
          // countdown.style.display = "none";
          // content.style.display = "block";

          clearInterval(this.countdownInterval);
        }
        //seconds
      }, 0);
    },
    async getOneUser(event, UID = null) {
      console.log("msteryious space:", UID);
      let id = UID !== null ? UID : this.userToFindID;
      if (!id) return console.log("missing id");
      console.log("right before", this.userToFindID);
      console.log("user id before", id);
      const user = await getUser(id);
      console.log("user before", user);
      if (!this.allUsers.some((e) => e._id === user._id)) {
        this.allUsers.push(user);
      }
      this.selectUser(user._id);
      this.userToFindID = "";
    },
    async selectUser(id) {
      console.log("id", id);
      let allUsers = this.allUsers;
      let selection = allUsers.filter((user) => {
        return user._id === id;
      });
      if (!selection[0]) {
        await this.getOneUser(null, id);
      } else {
        if (this.$refs.user) {
          this.$refs.user.resetState();
        }

        this.selectedUser = selection[0];
      }
    },
    selectSession(id) {
      /* Reset past session pre-selecting upcoming */
      if (this.selectedPastSession) {
        this.selectedPastSession = null;
      }

      if (this.selectedSession) {
        this.selectedSession = null;
      }

      /* Find and set selected upcoming session */
      let allSession = this.upcomingSessionsFor8Days;
      let selection = allSession.filter((session) => {
        return session._id === id;
      });
      this.selectedSession = selection[0];
    },
    selectPastSession(session) {
      if (this.selectedPastSession) {
        this.selectedPastSession = null;
      }

      if (this.selectedSession) {
        this.selectedSession = null;
      }
      this.selectedPastSession = session;
    },
    clearSelection() {
      this.selectedUser = null;
      this.selectedSession = null;
    },
    setSearchType(type) {
      this.searchType = type;
    },
    setSortType(type) {
      if (type == "reverse") {
        this.reversed = !this.reversed;
      } else {
        this.sortType = type;
      }
    },
    setCurrentView(view) {
      this.currentView = view;
      if (view == "sessions") {
        this.searchType = "all";
      } else {
        this.searchType = "displayName";
      }
    },
    async manuallyVerify(userID) {
      await manuallyVerify(userID);
      await this.refreshData();
    },
    async toggleRematchValue(sessionData) {
      await toggleRematchValue(sessionData);
      await this.refreshData();
    },
    async rectifySession(sessionID) {
      await rectifySession(sessionID);
      await this.refreshData();
    },
    async rectifyAccount(userID) {
      this.rectifyingInProgress = true;
      await rectifyAccount(userID);
      await this.refreshData();
      this.rectifyingInProgress = false;
    },
    openBox(box) {
      if (box == "dog") {
        this.dogClosed = false;
        this.nyanClosed = true;
      } else if (box == "nyan") {
        this.dogClosed = true;
        this.nyanClosed = false;
        this.$refs.dog.popMystery("close");
      }
    },
    closeBox(box) {
      if (box == "dog") {
        this.dogClosed = true;
        this.$refs.dog.popMystery("close");
      } else if (box == "nyan") {
        this.nyanClosed = true;
      }
    },
  },
};
</script>

<style scoped>
@import "./Styles/InternalStats.css";

.ness-start {
  background-color: #ce3a89;
  padding: 10px;
  margin-bottom: 14px;
  color: white;
  font-size: 17px;
  text-align: center;
}

.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: url("https://i.imgur.com/D99Ztsd.jpg");
  background-size: cover;
  z-index: -1;
  opacity: 0.3;
}
.flamingo {
  font-size: 22px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  text-align: center;
  text-anchor: middle;
  align-items: center;
  opacity: 0.7;
  border-radius: 360px;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-left: 5px;
}
.countdown-box {
  display: flex;
  flex-direction: column;
  padding: 4px 10px;
  border: 2px solid;
  /* margin-left: 10px; */
  margin-bottom: 10px;
  background: #edf0f5;
  -o-border-image: linear-gradient(to bottom right, #b827fc 0, #2c90fc 25%, #b8fd33 50%, #fec837 75%, #fd1892);
  border-image: linear-gradient(to bottom right, #b827fc 0, #2c90fc 25%, #b8fd33 50%, #fec837 75%, #fd1892);
  border-image-slice: 1;
}
#headline {
  text-align: center;
}
.countdown-parts {
  display: flex;
}
#countdown {
  margin: 0 auto;
  text-align: center;
}
.countdown-part {
  margin: 0px 3px;
  font-size: 20px;
}
.countdown-parts li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 4px;
}
</style>
